import { useEffect } from "react";
import { useTable } from "react-table";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { Table as BaseTable } from "reactstrap";
import Loading from "../../../../components/Loaders/Loading";
import { isNonProductiveTimeSheet } from "../../components/TimeSheetTable/helpers";

function Table({ loading, columns, data, footer = true, hiddenColumns, ...props }) {
    const { t } = useTranslation();
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        footerGroups,
        rows,
        prepareRow,
        setHiddenColumns
    } = useTable(
        {
            columns,
            data,
            initialState: { hiddenColumns }
        },
        (hooks) => {
            hooks.getRowProps.push((props = {}, { row, instance: { rows } }) => {
                const { locked, date, isAdded } = row.original;
                const isNonProductive = isNonProductiveTimeSheet(row.original);
                const previousRow = row.index > 0 ? rows[row.index - 1] : undefined;
                const previousDate = previousRow?.original?.date;

                props.className = classNames(
                    props.className,
                    (previousDate !== date) ? "date-seperator" : 'inside-date',
                    locked && "locked",
                    (!isAdded) && "paid",

                    isNonProductive && "is-non-productive",
                );
                return props;
            });
        }
    );

    useEffect(() => {
        setHiddenColumns(hiddenColumns)
    }, [hiddenColumns, setHiddenColumns]);

    return (
        <BaseTable
            className="align-items-center table-flush"
            hover
            responsive
            {...getTableProps(props)}
        >
            <thead className="thead-light">
                {headerGroups.map((headerGroup) => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map((column) => {
                            return (
                                <th
                                    {...column.getHeaderProps({
                                        ...column.headCustomProps,
                                    })}
                                    style={{ color: "#000000b5" }}
                                >
                                    {column.render("Header")}
                                </th>
                            );
                        })}
                    </tr>
                ))}
            </thead>

            <tbody {...getTableBodyProps()}>
                {loading ? (
                    <tr>
                        <td colSpan="999">
                            <div className="d-flex justify-content-center">
                                <Loading />
                            </div>
                        </td>
                    </tr>
                ) : rows.length === 0 ? (
                    <tr>
                        <td colSpan="999">
                            <div className="d-flex justify-content-center">
                                {t("no-data")}
                            </div>
                        </td>
                    </tr>
                ) : (
                    rows.map((row) => {
                        prepareRow(row);
                        return (
                            <tr {...row.getRowProps()}>
                                {row.cells.map((cell) => {
                                    const props =
                                        cell.column.getCellCustomProps?.(
                                            cell.row.original,
                                        ) || {};
                                    if (props.rowSpan === 0) {
                                        return null;
                                    }
                                    return (
                                        <td {...cell.getCellProps(props)}>
                                            {cell.render("Cell")}
                                        </td>
                                    );
                                })}
                            </tr>
                        );
                    })
                )}
            </tbody>

            {footer && (
                <tfoot>
                    {footerGroups.map((group) => (
                        <tr {...group.getFooterGroupProps()}>
                            {group.headers.map((column) => (
                                <td {...column.getFooterProps()}>
                                    {column.render("Footer")}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tfoot>
            )}
        </BaseTable>
    );
}

export default Table;
